import { applyAlphaToColor } from "./applyAlphaToColor.js";
import { colorToRGBA } from "./colorToRGBA.js";
import { convertHexAToRGBA } from "./convertHexAToRGBA.js";
import { convertRGBAToHexA } from "./convertRGBAToHexA.js";
import { expandHexColor } from "./expandHexColor.js";
import { getColorSqDistance } from "./getColorSqDistance.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  applyAlphaToColor,
  colorToRGBA,
  convertHexAToRGBA,
  convertRGBAToHexA,
  expandHexColor,
  getColorSqDistance
};
//# sourceMappingURL=index.js.map
